(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) return;

  function revealSlide(slide) {
    if (!slide) return;
    var content = slide.querySelector('.slide__content');
    var media = slide.querySelector('.slide__image, .slide__video');

    [content, media].forEach(function (el) {
      if (!el) return;
      el.classList.remove('reveal-in');
      // Force reflow so the animation restarts every time a slide becomes active.
      void el.offsetWidth;
    });

    requestAnimationFrame(function () {
      if (content) content.classList.add('reveal-in');
      if (media) media.classList.add('reveal-in');
    });
  }

  // Reveal whichever slide is already active at load (e.g. the first hero slide),
  // since no slideshow:select event fires for markup that's just server-rendered.
  document.querySelectorAll('slideshow-slide[aria-hidden="false"]').forEach(revealSlide);

  // slideshow:select fires exactly once per genuine slide change, regardless of
  // whether it was triggered by a click, arrow, drag, autoplay, or scroll.
  //
  // aria-hidden looked like the natural thing to key the reveal off of, but it's
  // noisier than it appears: select() sets it to "false" immediately on click,
  // then the component's own IntersectionObserver independently corrects it against
  // the real scroll position as the transition plays out - genuinely bouncing
  // false -> true -> false (not just redundant same-value writes) while the slide
  // is mid-transition. Each of those swings restarted the fade-in from scratch,
  // which is the "flashes twice" bug. slideshow:select sidesteps all of that: it's
  // dispatched once by the component itself when a transition is actually decided,
  // independent of how aria-hidden gets reconciled underneath it.
  document.addEventListener('slideshow:select', function (event) {
    revealSlide(event.detail && event.detail.slide);
  });

  var revealTargets = document.querySelectorAll('[data-scroll-reveal]');

  if (!revealTargets.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-in');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  revealTargets.forEach(function (el) {
    observer.observe(el);
  });
})();
